<!-- 设备保养记录 -->
<style scoped="scoped" lang="scss">
.baoyangxianginput {
  width: 1.25rem;
}

.state {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-items: center;
}
</style>
<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/mould/repair/record/page" getKey="rows" :columns="columns">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('mujuweixiudanhao')">
            <el-input v-model="yt.conditions.repairNo"></el-input>
          </el-form-item>
          <el-form-item :label="$t('mujubianhao(jingzhun)')">
            <el-input v-model="yt.conditions.noEqual"></el-input>
          </el-form-item>
          <el-form-item :label="$t('mujumingcheng')" prop="moldId">
            <yi_cross_select multiple :component="'web_base_mould_list'" :ids.sync="yt.conditions.moldIds"> </yi_cross_select>
          </el-form-item>
          <el-form-item :label="$t('weixiuzhuangtai')">
            <el-select v-model="yt.conditions.status">
              <el-option :label="$t('daichuli')" :value="0"></el-option>
              <el-option :label="$t('chulizhong')" :value="1"></el-option>
              <el-option :label="$t('yiwancheng')" :value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('songxiuleixing')">
            <yi_dictionary_select :max="1" clearable type="MOULD_REPAIR_TYPE" :ids.sync="yt.conditions.repairType"> </yi_dictionary_select>
          </el-form-item>
          <el-form-item :label="$t('jinjichengdu')">
            <el-select v-model="yt.conditions.level">
              <el-option :label="$t('yiban')" :value="0"></el-option>
              <el-option :label="$t('jinji')" :value="1"></el-option>
              <el-option :label="$t('teji')" :value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('chuangjianshijian')">
            <yi_time_input type="datetimerange" :start.sync="yt.conditions.createTime" :end.sync="yt.conditions.endTime"> </yi_time_input>
          </el-form-item>
          <el-form-item :label="$t('oaAuditStatus')">
            <yi_dictionary_select :max="1" clearable type="OA_AUDIT_STATUS" :ids.sync="yt.conditions.oaAuditStatus"> </yi_dictionary_select>
          </el-form-item>
          <el-form-item>
            <el-button @click="yt.get(1)" type="primary" plain="plain">
              {{ $t('sousuo') }}
            </el-button>
            <el-button @click="yt.clear({ orderBy: 'repairNo desc' })">{{ $t('chongzhi') }} </el-button>
            <yi_curd_expand_button></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>
      <!-- 左侧按钮插槽 -->
      <template #buttonsL>
        <el-button size="mini" @click="yt.showEditDialog('xinzeng', null, 'w1')" type="primary" v-if="utils.checkPower('web_mold_management_mold_repair_create')" v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { s1: '模具维修-新增' } }">
          {{ $t('xinzeng') }}
        </el-button>

        <el-button size="mini" @click="yt.showEditDialog('customSave', null, 'w1')" type="primary" v-if="utils.checkPower('web_mold_management_mold_repair_customSave')">
          {{ $t('customSave') }}
        </el-button>
        <el-button :loading="exportLoading" size="mini" @click="exportDetailExcel()" v-if="utils.checkPower('web_mold_management_mold_repair_export_detail')" type="primary">
          {{ $t('daochumingxixiang') }}
        </el-button>
      </template>
      <!-- 右侧按钮插槽 -->
      <template #buttonsR>
        <el-button size="mini" icon="yicon yicon-export" :title="$t('daochu')" @click="exportExcel()"></el-button>
        <el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')" @click="yt.showColumnsDialog()"></el-button>
      </template>
      <!-- 自定义某个字段 -->
      <template #jinjichengdu="scope">
        <template v-if="scope.row.level == 0">
          <div class="state">
            <span style="width: 8px;height: 8px;border-radius: 50%;background-color: #909399;"></span>
            <span style="margin-left: 5px;">{{ $t('yiban') }}</span>
          </div>
        </template>
        <template v-if="scope.row.level == 1">
          <div class="state">
            <span style="width: 8px;height: 8px;border-radius: 50%;background-color: #E6A23C;"></span>
            <span style="margin-left: 5px;">{{ $t('jinji') }}</span>
          </div>
        </template>
        <template v-if="scope.row.level == 2">
          <div class="state">
            <span style="width: 8px;height: 8px;border-radius: 50%;background-color: #F56C6C;"></span>
            <span style="margin-left: 5px;">{{ $t('teji') }}</span>
          </div>
        </template>
      </template>
      <!-- 送修类型 -->
      <!-- <template #songxiuleixing="scope">
				<template v-if="scope.row.repairType == 0">
					<span>{{ $t('xiumu') }}</span>
				</template>
				<template v-if="scope.row.repairType == 1">
					<span>{{ $t('gaimu') }}</span>
				</template>
			</template> -->
      <template #tupian="scope">
        <yi_upload :readOnly="true" :ids.sync="scope.row.imgInfoIds" :limit="5"> </yi_upload>
      </template>
      <template #caozuo="scope">
        <el-row :gutter="10">
          <el-col :span="0.1" v-if="scope.row.status == 0">
            <el-popconfirm :title="$t('quedingkaishiweixiu?')" :confirm-button-text="$t('kaishiweixiu')" @confirm="startRepair(scope.row)">
              <el-button type="text" slot="reference" :loading="scope.row.startRepairLoading" v-if="utils.checkPower('web_mold_management_mold_repair_start_button')" v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { s1: '模具维修-开始维修' } }">{{ $t('kaishiweixiu') }}</el-button>
            </el-popconfirm>
          </el-col>
          <el-col :span="0.1" v-if="scope.row.status == 0">
            <el-button type="text" @click="yt.showEditDialog('bianji', scope.row, 'w1')" v-if="utils.checkPower('web_mold_management_mold_repair_update')">{{ $t('bianji') }} </el-button>
            <el-button type="text" class="font-color-danger" v-if="utils.checkPower('web_mold_management_mold_repair_delete')" @click="yt.remove(scope.row, '/web/mould/repair/record/delete')">{{ $t('shanchu') }} </el-button>
          </el-col>
          <el-col :span="0.1" v-if="scope.row.status == 1">
            <el-button type="text" v-if="utils.checkPower('web_mold_management_mold_repair_finish')" @click="yt.showEditDialog('wanchengweixiu', scope.row, 'w2', beforeShowEditDialog)" v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { s1: '模具维修-完成维修' } }">
              {{ $t('wanchengweixiu') }}
            </el-button>
          </el-col>
          <el-col :span="0.1" v-if="scope.row.status == 2">
            <el-button type="text" @click="yt.showEditDialog('weixiuxiangqing', scope.row, 'w2')">
              {{ $t('weixiuxiangqing') }}
            </el-button>
          </el-col>
        </el-row>
      </template>

      <template #weixiudengdanshichang="scope">
        {{ formatMilliseconds(scope.row.repairWaitingTime) }}
      </template>

      <template #weixiuhaoshi="scope">
        {{ formatMilliseconds(scope.row.repairDuration) }}
      </template>
    </yi_curd_table>
    <el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog" :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
      <!-- 新增弹窗-->
      <template v-if="yt.editObj.action == 'xinzeng'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item :label="$t('mujubianma/mingcheng')" need>
            <yi_cross_select :selectTitle="'code,name'" :component="'web_base_mould_list'" :max="1" @change="stdValueChange(index, indexItem)" :ids.sync="yt.editObj.moldId"> </yi_cross_select>
          </el-form-item>
          <el-form-item :label="$t('songxiuleixing')" required>
            <yi_dictionary_select :max="1" clearable type="MOULD_REPAIR_TYPE" :ids.sync="yt.editObj.repairType"> </yi_dictionary_select>
          </el-form-item>
          <el-form-item :label="$t('jinjichengdu')" required>
            <el-select v-model="yt.editObj.level">
              <el-option :label="$t('yiban')" :value="0"></el-option>
              <el-option :label="$t('jinji')" :value="1"></el-option>
              <el-option :label="$t('teji')" :value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('weixiushifu')">
            <el-input v-model="yt.editObj.repairer"></el-input>
          </el-form-item>
          <el-form-item :label="$t('yujiwanchengshijian')">
            <el-date-picker type="datetime" v-model="yt.editObj.expectedEndTime" :format="'yyyy-MM-dd HH:mm:ss'"></el-date-picker>
          </el-form-item>
          <el-form-item :label="$t('xuqiushijian')" label-width="150px">
            <yi_time_input :minMaxBase="'current'" type="datetime" :time.sync="yt.editObj.requiredTime"></yi_time_input>
          </el-form-item>
          <el-form-item :label="$t('miaoshu')" required>
            <el-input v-model="yt.editObj.faultDescription" type="textarea" :autosize="{ minRows: 3, maxRows: 3 }" :placeholder="$t('qingshuruneirong')" maxlength="400" show-word-limit> </el-input>
          </el-form-item>

          <el-row>
            <el-col :span="24">
              <!-- :isShowLimitMsg="false" -->
              <yi_upload style="margin-left: 20px;" :accept="'image/png, image/jpeg,image/gif'" :ids.sync="yt.editObj.imgInfoIds" :limit="5">
                <div slot="limitMsg">
                  <span style="margin-left: 12px;font-size: 14px;color: #909399;">
                    {{ $t('zuiduoshangchuan') }}
                  </span>
                  <span style="font-weight: bold;font-size: 14px;color: #419FFF;;">
                    <span>5</span>
                    <span style="color: #909399;font-size: 14px;font-weight: normal;">
                      {{ $t('zizhichitupian') }}
                    </span>
                  </span>
                </div>
              </yi_upload>
            </el-col>
          </el-row>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button :loading="store.state.global_loading" size="mini" @click="yt.req('POST', '/web/mould/repair/record/create')" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>

      <template v-if="yt.editObj.action == 'customSave'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item :label="$t('mujubianma/mingcheng')" need>
            <yi_cross_select :selectTitle="'code,name'" :component="'web_base_mould_list'" :max="1" @change="stdValueChange(index, indexItem)" :ids.sync="yt.editObj.moldId"> </yi_cross_select>
          </el-form-item>
          <el-form-item :label="$t('songxiuleixing')" required>
            <yi_dictionary_select :max="1" clearable type="MOULD_REPAIR_TYPE" :ids.sync="yt.editObj.repairType"> </yi_dictionary_select>
          </el-form-item>
          <el-form-item :label="$t('jinjichengdu')" required>
            <el-select v-model="yt.editObj.level">
              <el-option :label="$t('yiban')" :value="0"></el-option>
              <el-option :label="$t('jinji')" :value="1"></el-option>
              <el-option :label="$t('teji')" :value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('weixiushifu')">
            <el-input v-model="yt.editObj.repairer"></el-input>
          </el-form-item>
          <el-form-item :label="$t('yujiwanchengshijian')">
            <el-date-picker type="datetime" v-model="yt.editObj.expectedEndTime" :format="'yyyy-MM-dd HH:mm:ss'"></el-date-picker>
          </el-form-item>
          <el-form-item :label="$t('xuqiushijian')" label-width="150px" required>
            <yi_time_input :minMaxBase="'current'" type="datetime" :time.sync="yt.editObj.requiredTime"></yi_time_input>
          </el-form-item>
          <el-form-item :label="$t('miaoshu')" required>
            <el-input v-model="yt.editObj.faultDescription" type="textarea" :autosize="{ minRows: 3, maxRows: 3 }" :placeholder="$t('qingshuruneirong')" maxlength="400" show-word-limit> </el-input>
          </el-form-item>

          <el-row>
            <el-col :span="24">
              <!-- :isShowLimitMsg="false" -->
              <yi_upload style="margin-left: 20px;" :accept="'image/png, image/jpeg,image/gif'" :ids.sync="yt.editObj.imgInfoIds" :limit="5">
                <div slot="limitMsg">
                  <span style="margin-left: 12px;font-size: 14px;color: #909399;">
                    {{ $t('zuiduoshangchuan') }}
                  </span>
                  <span style="font-weight: bold;font-size: 14px;color: #419FFF;;">
                    <span>5</span>
                    <span style="color: #909399;font-size: 14px;font-weight: normal;">
                      {{ $t('zizhichitupian') }}
                    </span>
                  </span>
                </div>
              </yi_upload>
            </el-col>
          </el-row>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button :loading="store.state.global_loading" size="mini" @click="customSave()" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>

      <!-- 编辑弹窗 -->
      <template v-if="yt.editObj.action == 'bianji'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item required :label="$t('mujubianma/mingcheng')" need>
            <yi_cross_select :selectTitle="'code,name'" :component="'web_base_mould_list'" :max="1" :ids.sync="yt.editObj.moldId"> </yi_cross_select>
          </el-form-item>
          <el-form-item :label="$t('songxiuleixing')" required>
            <yi_dictionary_select :max="1" clearable type="MOULD_REPAIR_TYPE" :ids.sync="yt.editObj.repairType"> </yi_dictionary_select>
          </el-form-item>
          <el-form-item :label="$t('jinjichengdu')" required>
            <el-select v-model="yt.editObj.level">
              <el-option :label="$t('yiban')" :value="0"></el-option>
              <el-option :label="$t('jinji')" :value="1"></el-option>
              <el-option :label="$t('teji')" :value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('weixiushifu')">
            <el-input v-model="yt.editObj.repairer"></el-input>
          </el-form-item>
          <el-form-item :label="$t('miaoshu')" required>
            <el-input v-model="yt.editObj.faultDescription" type="textarea" :autosize="{ minRows: 3, maxRows: 3 }" :placeholder="$t('qingshuruneirong')" maxlength="400" show-word-limit> </el-input>
          </el-form-item>

          <el-row>
            <el-col :span="24">
              <yi_upload style="margin-left: 20px;" :accept="'image/png, image/jpeg,image/gif'" :ids.sync="yt.editObj.imgInfoIds" :limit="5">
                <div slot="limitMsg">
                  <span style="margin-left: 12px;font-size: 14px;color: #909399;">
                    {{ $t('zuiduoshangchuan') }}
                  </span>
                  <span style="font-weight: bold;font-size: 14px;color: #419FFF;;">
                    <span>5</span>
                    <span style="color: #909399;font-size: 14px;font-weight: normal;">
                      {{ $t('zizhichitupian') }}
                    </span>
                  </span>
                </div>
              </yi_upload>
            </el-col>
          </el-row>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button :loading="store.state.global_loading" size="mini" @click="yt.req('POST', '/web/mould/repair/record/update')" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>
      <!-- "完成维修"弹窗 -->
      <template v-if="yt.editObj.action == 'wanchengweixiu'">
        <div class="dialog-scroller">
          <el-form ref="form" size="mini" style="margin-left: -130px;" :inline="true">
            <el-form-item :label="$t('guzhangleixing')" label-width="410px" size="mini" style="margin-left: -195px;margin-top: 50px;">
              <yi_dictionary_select :type="'CUSTOMER_MOULD_FAULT_TYPE'" :ids.sync="yt.editObj.mouldFaultType"> </yi_dictionary_select>
            </el-form-item>
            <br />
            <el-form-item :label="$t('beizhu')" label-width="410px" size="mini" style="margin-left: -195px;margin-top: 50px;">
              <el-input type="textarea" v-model="yt.editObj.repairRemark" :autosize="{ minRows: 4, maxRows: 4 }" :placeholder="$t('qingshuruneirong')" maxlength="400" show-word-limit> </el-input>
            </el-form-item>
            <div style="display: flex;flex-wrap: nowrap;">
              <div style="margin-left: -20px;">
                <el-form-item :label="$t('weixiufangfa')" required label-width="280px"> </el-form-item>
              </div>
              <div style="margin-left: -10px;">
                <el-form-item :label="$t('weixiushuoming')" required label-width="180px"> </el-form-item>
              </div>
              <div style="margin-left: -10px;">
                <el-form-item :label="$t('beizhu')" label-width="180px"> </el-form-item>
              </div>
              <div style="margin-left: -10px;">
                <el-form-item :label="$t('shangchuantupian')" label-width="220px"> </el-form-item>
              </div>
            </div>
          </el-form>
          <el-form style="margin-left: -180px;">
            <el-form-item v-for="(item, index) in yt.editObj.repairRecordDetails" :key="index" label-width="180px" size="mini">
              <el-col :span="0.1">
                <el-button type="text" icon="el-icon-remove-outline" @click="deleteItem(index)"> </el-button>
              </el-col>
              <el-col :span="0.8">&nbsp;</el-col>
              <el-col :span="4">
                <!--								<el-select v-model="item.repairMethod" size="mini">-->
                <!--									<el-option v-for="(repairMethodItem, index) in repairMethod" :key="index"-->
                <!--										:label="repairMethodItem.label" :value="repairMethodItem.id"></el-option>-->
                <!--								</el-select>-->

                <yi_dictionary_select :type="'MJWXFF'" :ids.sync="item.repairMethod"> </yi_dictionary_select>
              </el-col>
              <el-col :span="2">&nbsp;</el-col>
              <el-col :span="3">
                <el-input v-model="item.repairDescription" class="baoyangxianginput" type="text" size="mini"> </el-input>
              </el-col>
              <el-col :span="3">&nbsp;</el-col>
              <el-col :span="2">
                <el-input v-model="item.repairMethodRemark" class="baoyangxianginput" type="text" size="mini"> </el-input>
              </el-col>
              <el-col :span="4">&nbsp;</el-col>
              <el-col :span="2">
                <yi_upload :accept="'image/png, image/jpeg'" :ids.sync="item.imgInfoIds" :limit="5">
                  <div slot="limitMsg"></div>
                </yi_upload>
              </el-col>
            </el-form-item>

            <el-form-item label-width="180px" size="mini">
              <el-col :span="4">
                <el-button type="text" icon="el-icon-circle-plus-outline" @click="addItem">
                  {{ $t('zengjiayitiaoweixiufangfa') }}
                </el-button>
              </el-col>
            </el-form-item>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button size="mini" @click="saveDraft" :loading="yt.editObj.loading"  v-if="utils.checkPower('web_mold_management_mold_repair_save_draft')">
            {{ $t('baocuncaogao') }}
          </el-button>
          <el-button size="mini" @click="finish" type="primary" :loading="yt.editObj.loading">
            {{ $t('wanchengweixiu') }}
          </el-button>
        </span>
      </template>
      <!-- 维修详情 -->
      <template v-if="yt.editObj.action == 'weixiuxiangqing'">
        <div class="dialog-scroller">
          <el-form :inline="true" ref="form" size="mini" style="margin-left: -130px;margin-top: 50px;">
            <el-form-item :label="$t('guzhangleixing')" label-width="410px" size="mini" style="margin-left: -172px;margin-top: 50px;" class="noborder" v-if="yt.editObj.mouldFaultType">
              <yi_dictionary_select disabled :type="'CUSTOMER_MOULD_FAULT_TYPE'" :ids.sync="yt.editObj.mouldFaultType"> </yi_dictionary_select>
            </el-form-item>
            <br />
            <!-- 备注 -->
            <el-form-item style="margin-left: -200px;" :label="$t('beizhu')" label-width="410px" size="mini"> {{ yt.editObj.repairRemark }} </el-form-item><br />
            <div style="display: flex;flex-wrap: nowrap;">
              <div style="margin-left: -68px;">
                <el-form-item :label="$t('weixiufangfa')" required label-width="310px"> </el-form-item>
              </div>
              <div style="margin-left: -10px;">
                <el-form-item :label="$t('weixiushuoming')" required label-width="210px"> </el-form-item>
              </div>
              <div style="margin-left: -10px;">
                <el-form-item :label="$t('beizhu')" label-width="210px"> </el-form-item>
              </div>
              <div style="margin-left: -10px;">
                <el-form-item :label="$t('shangchuantupian')" label-width="210px"> </el-form-item>
              </div>
            </div>
          </el-form>
          <el-form style="margin-left: -180px;">
            <el-form-item v-for="(item, index) in yt.editObj.repairRecordDetails" label-width="180px" size="mini">
              <el-col :span="0.1">&nbsp;</el-col>
              <el-col :span="4">
                <el-input :value="item.repairMethodName" />
              </el-col>
              <el-col :span="3">&nbsp;</el-col>
              <el-col :span="3">
                <el-input :value="item.repairDescription" type="text" size="mini"> </el-input>
              </el-col>
              <el-col :span="3">&nbsp;</el-col>
              <el-col :span="3">
                <el-input :value="item.repairMethodRemark" type="text" size="mini"> </el-input>
              </el-col>
              <el-col :span="4">&nbsp;</el-col>
              <el-col :span="3">
                <yi_upload style="margin-top: -10px;" :readOnly="true" :ids.sync="item.imgInfoIds" :limit="5"></yi_upload>
              </el-col>
            </el-form-item>
          </el-form>
        </div>
      </template>
    </el-dialog>
  </div>
</template>
<script type="text/javascript">
import XLSX from 'xlsx';

export default {
  name: 'web_mold_management_mold_repair_list',
  data() {
    return {
      repair: [],
      aa: [1636],
      files: [],
      leaveFactoryDate: new Date().getFullYear() + '-' + (new Date().getMonth() + 1) + '-' + new Date().getDate(),
      list: [],
      repairMethod: [],
      repairMethodItemList: [],
      repairMethodMap: new Map(),
      levelMap: {
        0: {
          color: '#67C23A',
          text: this.$t('yiban')
        },
        1: {
          color: '#F56C6C',
          text: this.$t('jinji')
        },
        2: {
          color: '#E6A23C',
          text: this.$t('teji')
        }
      },
      columns: [
        {
          label: 'mujuweixiudanhao',
          prop: 'repairNo',
          fixed: 'left'
        },
        {
          label: 'mujubianhao',
          prop: 'mold.no'
        },
        {
          label: 'mujubianma',
          prop: 'mold.code'
        },
        {
          label: 'mujumingcheng',
          prop: 'mold.name'
        },
        {
          label: 'songxiuleixing',
          prop: 'repairType',
          type: 'dictionary',
          key: 'MOULD_REPAIR_TYPE'
        },
        {
          label: 'jinjichengdu',
          prop: 'level',
          type: 'slot'
        },
        {
          label: 'shenqingren',
          prop: 'createByObject.nickname',
          width: 150
        },
        {
          label: 'chuangjianshijian',
          prop: 'createTime',
          type: 'time',
          width: 230
        },
        {
          label: 'yujiwanchengshijian',
          prop: 'expectedEndTime',
          type: 'time',
          width: 160
        },
        {
          label: 'miaoshu',
          prop: 'faultDescription'
        },
        {
          label: 'weixiuzhuangtai',
          type: 'tag',
          prop: 'status',
          tags: {
            0: {
              color: '#F56C6C',
              text: this.$t('daichuli')
            },
            1: {
              color: '#E6A23C',
              text: this.$t('chulizhong')
            },
            2: {
              color: '#67C23A',
              text: this.$t('yiwancheng')
            }
            // 4: {
            // 	color: '#969696',
            // 	text: this.$t('shibai')
            // }
          }
        },
        {
          label: 'weixiushifu',
          prop: 'repairer'
        },
        {
          label: 'xuqiushijian',
          prop: 'requiredTime',
          type: 'time'
        },
        {
          label: 'weixiudengdanshichang',
          prop: 'repairWaitingTime',
          type: 'slot'
        },
        {
          label: 'weixiuhaoshi',
          prop: 'repairDuration',
          type: 'slot'
        },
        {
          label: 'yanshouzhuangtai',
          prop: 'acceptanceStatus',
          type: 'tag',
          tags: {
            '0': {
              color: '#67C23A',
              text: this.$t('daiyanshou')
            },
            '1': {
              color: '#E6A23C',
              text: this.$t('yiyanshou')
            },
            '2': {
              color: '#F56C6C',
              text: this.$t('yanshouweitongguo')
            }
          }
        },
        {
          label: 'kaishiweixiuren',
          prop: 'startRepairerObject.nickname'
        },
        {
          label: 'weixiukaishishijian',
          prop: 'beginTime',
          type: 'time'
        },
        {
          label: 'wanchengweixiuren',
          prop: 'endRepairerObject.nickname'
        },
        {
          label: 'weixiujieshushijian',
          prop: 'endTime',
          type: 'time'
        },
        {
          label: 'tupian',
          type: 'slot',
          prop: 'repairByObject.nickname'
        },
        {
          label: 'oaAuditStatus',
          prop: 'oaAuditStatus',
          type: 'dictionary_tag',
          key: 'OA_AUDIT_STATUS'
        },
        {
          label: 'caozuo',
          type: 'slot',
          width: 160,
          fixed: 'right'
        }
      ]
    };
  },
  created() {
    setTimeout(() => {
      this.yt.conditions = {
        orderBy: 'repairNo desc'
      };
      this.yt.get(1);
      this.getRepairMethod();
    }, 300);
  },
  watch: {
    // 'yt.editObj.action': {
    // 	handler(n) {
    // 		if (n === 'wanchengweixiu') {
    // 			this.$set(this.yt.editObj, 'methodList', [{
    // 				label: '',
    // 				id: 0,
    // 			}])
    // 		}
    // 	},
    // 	immediate: false,
    // 	deep: true
    // }
  },
  methods: {
    formatMilliseconds(ms) {
      if (!ms || ms === 0) {
        return;
      }
      // 计算总秒数
      const totalSeconds = Math.floor(ms / 1000);

      // 计算天数和剩余时间
      const days = Math.floor(totalSeconds / 86400); // 1天=86400秒
      const remainingAfterDays = totalSeconds % 86400; // 扣除整天后的剩余秒数

      // 计算小时和剩余时间
      const hours = Math.floor(remainingAfterDays / 3600);
      const remainingAfterHours = remainingAfterDays % 3600;

      // 计算分钟和秒
      const minutes = Math.floor(remainingAfterHours / 60);
      const seconds = remainingAfterHours % 60;

      // 动态构建时间片段
      const parts = [];
      if (days > 0) parts.push(`${days}天`);
      if (hours > 0 || parts.length > 0) parts.push(`${hours}时`);
      if (minutes > 0 || parts.length > 0) parts.push(`${minutes}分`);
      parts.push(`${seconds}秒`);
      // 补零逻辑（仅补有效位）
      return parts
          .map((str, index) => {
            const num = parseInt(str);
            return num < 10 && index !== 0 ? `0${str}` : str; // 天数不补零
          })
          .join('');
    },
    customSave() {
      if (!this.yt.editObj.requiredTime) {
        this.$message.error(this.$t('xuqiushijian_not_null'));
        return;
      }

      this.http
        .post('/web/mould/repair/record/create', this.yt.editObj)
        .then(res => {
          this.yt.isShowEditDialog = false;
          this.utils.successMessage(this.$t(res.msg));
          this.yt.get(1);
        })
        .catch(msg => {
          this.utils.errorMessage(msg);
        });
    },
    exportExcel() {
      let params = this.yt.conditions;
      params.createTimeStart = params.createTime;
      params.createTimeEnd = params.endTime;
      // params.materialId = this.yt.conditions.materialIdList;
      // params.equipmentId = this.yt.conditions.equipmentIdList;
      // params.status = this.yt.conditions.statusList;
      // delete params.materialIdList;
      // delete params.equipmentIdList;
      // delete params.statusList;
      // delete params.orderBy;
      return this.http
        .get('/web/report/export/mould_repair_export', { params })
        .then(res => {
          this.$message.success(this.$t(res.msg));
          this.utils.event_hub.$emit('SHOW_HEADER_EXPORT_DIALOG');
        })
        .catch(error => {
          this.$message.error(this.$t(error));
        });
    },
    beforeShowEditDialog(editObj) {
      if (editObj.action === 'wanchengweixiu') {
        if(this.yt.editObj.repairRecordDetails != null && this.yt.editObj.repairRecordDetails.length > 0){
          editObj.repairRecordDetails = this.yt.editObj.repairRecordDetails;
        }else{
          editObj.repairRecordDetails = [
            {
              label: '',
              id: 0
            }
          ];
        }
      }
      this.repair = editObj;
      return editObj;
    },
    // 请求查询客户数据字典中的维修方法项
    async getRepairMethod() {
      let response = await this.http.get('/web/config/customer/dictionary/item/getDictionaryByTypeCode', {
        params: {
          code: 'MJWXFF'
        }
      });
      this.repairMethod = response.data;
      //遍历repairMethod，组成Map
      this.repairMethod.forEach(item => {
        //repairMethodMap是map类型
        this.repairMethodMap.set('id' +item.value, item);
      });
    },
    // 开始维修
    startRepair(editObj) {
      let params = editObj;
      this.$set(editObj, 'startRepairLoading', true);
      params.status = 1;
      this.http
        .post('/web/mould/repair/record/update', params)
        .then(res => {
          this.utils.successMessage(this.$t(res.msg));
          this.yt.get(1);
        })
        .catch(msg => {
          this.utils.errorMessage(msg);
        })
        .finally(() => {
          this.$set(editObj, 'startRepairLoading', false);
        });
    },
    saveDraft() {
      let params = this.repair;
      this.yt.editObj.loading = true;
      params.status = 1;
      this.http
        .post('/web/mould/repair/record/saveDraft', params)
        .then(res => {
          this.utils.successMessage(this.$t(res.msg));
          this.yt.get(1);
          this.yt.isShowEditDialog = false;
        })
        .catch(msg => {
          this.utils.errorMessage(msg);
        })
        .finally(() => {
          this.yt.editObj.loading = false;
        });
    },
    finish() {
      let params = this.repair;
      this.yt.editObj.loading = true;
      params.status = 2;
      this.http
        .post('/web/mould/repair/record/finish', params)
        .then(res => {
          this.utils.successMessage(this.$t(res.msg));
          this.yt.get(1);
          this.yt.isShowEditDialog = false;
        })
        .catch(msg => {
          this.utils.errorMessage(msg);
        })
        .finally(() => {
          this.yt.editObj.loading = false;
        });
    },
    // 添加维修方法项
    addItem() {
      this.yt.editObj.repairRecordDetails.push({
        method: '',
        repairDescription: '',
        imgInfoIds: []
      });
    },
    // 删除维修方法项
    deleteItem(key) {
      this.yt.editObj.repairRecordDetails = this.yt.editObj.repairRecordDetails.filter((item, index) => {
        return index !== key;
      });
    },
    exportDetailExcel() {
      this.exportLoading = true;
      //查询表格
      this.http.get('/web/mould/repair/record/exportDetail?pageNum=1&pageSize=9999', { params: { ...this.yt.conditions } }).then(res => {
        let tableFirst = [this.$t('weixiudanhao'),this.$t('mujubianhao'),this.$t('mujumingcheng'),
          // this.$t('chuangjianshijian'),
          this.$t('songxiuleixing'),this.$t('jinjichengdu'),this.$t('miaoshu'),this.$t('chuangjianshijian'),this.$t('weixiukaishishijian'),
          this.$t('weixiujieshushijian'),this.$t('youxiaoshijian'),this.$t('weixiudengdaishichang'),this.$t('weixiufangfa'),this.$t('weixiushuoming'),this.$t('caozuoren'),this.$t('beizhu')];
        let tableData = [];
        tableData.push(tableFirst);
        let listData = res.data.rows;
        if(listData!=null && listData!=undefined && listData.length > 0){
          for (let i = 0; i < listData.length; i++) {
            let dataArr = [];
            let item = listData[i];
            dataArr[tableFirst.indexOf(this.$t('weixiudanhao'))] = item.repairNo;
            dataArr[tableFirst.indexOf(this.$t('mujubianhao'))] = item.mold? item.mold.code:'';
            dataArr[tableFirst.indexOf(this.$t('mujumingcheng'))] = item.mold? item.mold.name:'';
            // dataArr[tableFirst.indexOf(this.$t('chuangjianshijian'))] = this.dayjs(listData[i].createTime).format('YYYY-MM-DD HH:mm:ss');
            dataArr[tableFirst.indexOf(this.$t('songxiuleixing'))] = this.$t(this.store.state.dictJson['MOULD_REPAIR_TYPE'][item.repairType]);
            dataArr[tableFirst.indexOf(this.$t('jinjichengdu'))] =  item.level !=null ? this.levelMap[item.level] ? this.levelMap[item.level].text : '' :'';
            dataArr[tableFirst.indexOf(this.$t('miaoshu'))] = item.faultDescription? item.faultDescription:'';
            dataArr[tableFirst.indexOf(this.$t('chuangjianshijian'))] = item.createTime?this.dayjs(item.createTime).format('YYYY-MM-DD HH:mm:ss'):'';
            dataArr[tableFirst.indexOf(this.$t('weixiukaishishijian'))] = item.beginTime?this.dayjs(item.beginTime).format('YYYY-MM-DD HH:mm:ss'):'';
            dataArr[tableFirst.indexOf(this.$t('weixiujieshushijian'))] = item.endTime?this.dayjs(item.endTime).format('YYYY-MM-DD HH:mm:ss'):'';
            dataArr[tableFirst.indexOf(this.$t('youxiaoshijian'))] = item.repairDuration?this.formatDetailExcelRepairDuration(item.repairDuration):'';
            dataArr[tableFirst.indexOf(this.$t('weixiudengdaishichang'))] = item.repairWaitingTime?this.formatDetailExcelRepairDuration(item.repairWaitingTime):'';
            dataArr[tableFirst.indexOf(this.$t('weixiufangfa'))] = item.repairMethod? this.repairMethodMap.get('id' +item.repairMethod) ? this.repairMethodMap.get('id' +item.repairMethod).label : '' :'';
            dataArr[tableFirst.indexOf(this.$t('weixiushuoming'))] = item.repairDescription? item.repairDescription:'';
            dataArr[tableFirst.indexOf(this.$t('caozuoren'))] = item.repairMethodUser? item.repairMethodUser.nickname:'';
            dataArr[tableFirst.indexOf(this.$t('beizhu'))] = item.repairMethodRemark? item.repairMethodRemark:'';
            tableData.push(dataArr);
          }
        }
        const worksheet = XLSX.utils.aoa_to_sheet(tableData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
        XLSX.writeFile(workbook, `模具维修明细_${this.dayjs().format('YYYY-MM-DD_HH-mm-ss')}.xlsx`);
      }).finally(() => {
        this.exportLoading = false;
      });
    },
    formatDetailExcelRepairDuration(ms) {
      if (!ms || ms === 0) {
        return;
      }
      // 计算总秒数
      const totalSeconds = Math.floor(ms / 1000);
      // 计算小时和剩余时间
      const hours = Math.floor(totalSeconds / 3600);
      const remainingAfterHours = totalSeconds % 3600;
      // 计算分钟和秒
      const minutes = Math.floor(remainingAfterHours / 60);
      const seconds = remainingAfterHours % 60;
      // 动态构建时间片段
      const parts = [];
      if (hours > 0 || parts.length > 0) parts.push(`${hours}时`);
      if (minutes > 0 || parts.length > 0) parts.push(`${minutes}分`);
      parts.push(`${seconds}秒`);
      // 补零逻辑（仅补有效位）
      return parts.map((str, index) => {
            const num = parseInt(str);
            return num < 10 && index !== 0 ? `0${str}` : str; // 天数不补零
          }).join('');
    },
  }
};
</script>
